import ApplicationController from './application_controller'

export default class extends ApplicationController {
  static values = { acceptUrl: String, edisclosureAccepted: Boolean, openOnConnect: Boolean, submitTarget: String }

  connect() {
    if (this.openOnConnectValue) this._showModal()
  }

  intercept(event) {
    const carrierChosen = new FormData(this.element).get('quote[carrier_chosen]')
    if (carrierChosen !== 'gaig' || this.edisclosureAcceptedValue) return
    event.preventDefault()
    this._showModal()
  }

  async accept() {
    try {
      await this._saveEDisclosureAcceptance()
      this._closeModal()
      if (this.submitTargetValue) {
        this.element.requestSubmit(document.getElementById(this.submitTargetValue))
      } else {
        window.location.reload()
      }
    } catch (error) {
      this._showError('Something went wrong. Please try again or contact support.')
    }
  }

  dismiss() {
    this._closeModal()
  }

  _showModal() {
    document.getElementById('disclosure-modal')?.classList.remove('hidden')
  }

  _closeModal() {
    document.getElementById('disclosure-modal')?.classList.add('hidden')
  }

  async _saveEDisclosureAcceptance() {
    const response = await fetch(this.acceptUrlValue, {
      method: 'PATCH',
      headers: { 'X-CSRF-Token': this._csrfToken() },
    })
    if (!response.ok) throw new Error(`Server error: ${response.status}`)
  }

  _showError(message) {
    const flash = document.createElement('div')
    flash.className = 'z-50 absolute w-full left-0 top-0 bg-red-600 flash'
    flash.innerHTML = `
      <div class="max-w-7xl mx-auto py-3 px-3 sm:px-6 lg:px-8">
        <div class="pr-16 sm:text-center sm:px-16">
          <p class="font-medium text-white">${message}</p>
        </div>
        <div class="absolute inset-y-0 right-0 pt-1 pr-1 flex items-start sm:pt-1 sm:pr-2 sm:items-start">
          <button type="button" onclick="this.closest('.flash').remove()"
                  class="flex p-2 rounded-md hover:bg-red-500 focus:outline-none focus:ring-2 focus:ring-white">
            <svg class="h-6 w-6 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
            </svg>
          </button>
        </div>
      </div>`
    document.body.prepend(flash)
  }

  _csrfToken() {
    return document.querySelector('meta[name="csrf-token"]')?.content
  }
}